if (!customElements.get('product-breadcrumb')) {
  const STORAGE_KEY = 'rockAngelProductCollection';
  const INVALID_HANDLES = new Set(['all', 'frontpage', 'collections']);

  function isInvalidCollection(handle, title, url) {
    const normalizedHandle = (handle || '').toLowerCase();
    const normalizedTitle = (title || '').trim().toLowerCase();
    const normalizedUrl = (url || '').replace(/\/+$/, '');

    return (
      INVALID_HANDLES.has(normalizedHandle) ||
      normalizedTitle === 'collections' ||
      normalizedUrl === '/collections'
    );
  }

  class ProductBreadcrumb extends HTMLElement {
    connectedCallback() {
      this.restoreFromStorage();
      this.syncFromContext();
    }

    syncFromContext() {
      const { productHandle, collectionHandle, collectionTitle, collectionUrl } = this.dataset;
      if (!productHandle || !collectionHandle) return;
      if (isInvalidCollection(collectionHandle, collectionTitle, collectionUrl)) return;

      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          productHandle,
          collectionHandle,
          collectionTitle,
          collectionUrl,
        })
      );
    }

    restoreFromStorage() {
      if (this.dataset.collectionSource === 'context') return;

      let stored;
      try {
        stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      } catch (error) {
        return;
      }

      if (
        !stored ||
        stored.productHandle !== this.dataset.productHandle ||
        !stored.collectionHandle ||
        isInvalidCollection(stored.collectionHandle, stored.collectionTitle, stored.collectionUrl)
      ) {
        return;
      }

      this.renderCollection(stored.collectionTitle, stored.collectionUrl);
      this.dataset.collectionHandle = stored.collectionHandle;
      this.dataset.collectionTitle = stored.collectionTitle;
      this.dataset.collectionUrl = stored.collectionUrl;
      this.dataset.collectionSource = 'context';
    }

    renderCollection(title, url) {
      if (isInvalidCollection('', title, url)) return;

      const container = this.querySelector('[data-breadcrumb-collection]');
      if (!container) return;

      const separator = document.createElement('span');
      separator.className = 'breadcrumb-sep product-breadcrumb__desktop';
      separator.setAttribute('aria-hidden', 'true');
      separator.textContent = '/';

      const link = document.createElement('a');
      link.href = url;
      link.textContent = title;

      container.replaceChildren(separator, link);
      this.classList.remove('product-breadcrumb--no-collection');

      const mobileRoot = this.querySelector('[data-breadcrumb-mobile-root]');
      if (mobileRoot) {
        mobileRoot.replaceChildren();
        mobileRoot.hidden = true;
      }
    }
  }

  customElements.define('product-breadcrumb', ProductBreadcrumb);

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href*="/products/"]');
      if (!link) return;

      let collectionHandle;
      let collectionTitle;
      let collectionUrl;

      const card = link.closest('[data-collection-handle]');
      if (card) {
        collectionHandle = card.dataset.collectionHandle;
        collectionTitle = card.dataset.collectionTitle;
        collectionUrl = card.dataset.collectionUrl;
      } else {
        const collectionMatch = window.location.pathname.match(/\/collections\/([^/?#]+)/);
        if (!collectionMatch) return;

        collectionHandle = collectionMatch[1];
        collectionUrl = `/collections/${collectionHandle}`;
        collectionTitle =
          document.querySelector('.collection-banner__title')?.textContent?.trim() || collectionHandle;
      }

      if (isInvalidCollection(collectionHandle, collectionTitle, collectionUrl)) return;

      const productMatch = new URL(link.href, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
      if (!productMatch) return;

      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          productHandle: productMatch[1],
          collectionHandle,
          collectionTitle,
          collectionUrl,
        })
      );
    },
    true
  );
}
